<template>
  <div class="container-right_sidebar">
    <p v-if="ticketStore.isChatMeTicket" class="section-label">
      {{ $t("ticket.roomInformation") }}
    </p>
    <p v-else="" class="section-label">
      {{ $t("ticket.visitor_info") }}
    </p>

    <div style="display: grid; gap: 1em">
      <EditableLabel
        v-if="ticketStore.isChatMeTicket"
        icon="UsersIcon"
        :placeholder="$t('ticket.enter_name')"
        :editable="false"
        type-data="name"
        :store="ticketStore"
        :meta-data="ticketStore.selectedChatMeTicketDetail.chatMeRoomId"
        :default-data="ticketStore.selectedChatMeTicketDetail.renameRoom"
        validate-data="text"
      />
      <EditableLabel
        v-else
        icon="UserIcon"
        :placeholder="$t('ticket.enter_name')"
        :editable="true"
        type-data="name"
        :store="ticketStore"
        :meta-data="ticketStore.selectedTicketCustomer.id"
        :default-data="ticketStore.selectedTicketCustomer.name"
        validate-data="text"
      />

      <EditableLabel
        v-if="!ticketStore.isChatMeTicket"
        icon="MailIcon"
        :placeholder="$t('ticket.enter_email')"
        :editable="false"
        type-data="email"
        :store="ticketStore"
        :meta-data="ticketStore.selectedTicketCustomer.id"
        :default-data="ticketStore.selectedTicketCustomer.email"
        validate-data="email"
      />
      <!-- <EditableLabel v-else
        icon="MailIcon"
        :placeholder="$t('ticket.enter_email')"
        :editable="false"
        type-data="email"
        :store="ticketStore"
        :meta-data="ticketStore.selectedTicketCustomer.id"
        :default-data="ticketStore.selectedTicketCustomer.email"
        validate-data="email"
      /> -->

      <EditableLabel
        v-if="!ticketStore.isChatMeTicket"
        icon="PhoneIcon"
        :placeholder="$t('ticket.enter_phone_number')"
        :editable="true"
        type-data="phone"
        :store="ticketStore"
        :meta-data="ticketStore.selectedTicketCustomer.id"
        :default-data="ticketStore.selectedTicketCustomer.phone"
        validate-data="number"
      />

      <EditableLabel
        v-if="!ticketStore.isChatMeTicket"
        icon="MonitorIcon"
        placeholder="Enter Name"
        :default-data="ticketStore.selectedTicketCustomer.device"
      />

      <EditableLabel
        v-if="!ticketStore.isChatMeTicket"
        icon="MapPinIcon"
        placeholder="Enter Name"
        :default-data="ticketStore.selectedTicketCustomer.ipAddress"
      />

      <EditableLabel
        v-if="!ticketStore.isChatMeTicket"
        icon="AlertCircleIcon"
        :default-data="ticketStore.selectedTicketCustomer.meta"
      />
    </div>
  </div>
</template>
<script>
import useTicketStore from "@/store-pinia/useTicketStore";
import { ref } from "@vue/composition-api";
import CustomerRepository from "@/repositories/Api/CustomerRepository";
import EditableLabel from "@/components/global-components/EditableLabel.vue";

export default {
  components: {
    EditableLabel,
  },
  setup() {
    const ticketStore = useTicketStore();

    const nameForm = ref("");
    const emailForm = ref("");
    const phoneForm = ref("");
    const isEditName = ref(false);
    const isEditEmail = ref(false);
    const isEditPhone = ref(false);

    function handleSubmitUpdateProfile(payload) {
      CustomerRepository.updateCustomerProfile(
        { ...payload },
        ticketStore.getSelectedTicketDetailCustomerID
      )
        .then((response) => {
          console.log(response);
        })
        .then(() => {
          ticketStore.getTicketsAsync();
        });
    }

    function resetForm() {
      nameForm.value = "";
      emailForm.value = "";
      phoneForm.value = "";
    }

    function handleCloseEditProfile() {
      resetForm();
    }

    return {
      isEditName,
      isEditEmail,
      isEditPhone,
      ticketStore,
      nameForm,
      emailForm,
      phoneForm,
      resetForm,
      handleCloseEditProfile,
      handleSubmitUpdateProfile,
    };
  },
};
</script>

<style lang="scss" scoped>
.clickable-icon {
  cursor: pointer;
}

.label-container {
  display: flex;
  gap: 1em;
}

.container-right_sidebar {
}
</style>
